export const CSR_OBO_ROLES = [
    { display: "CSR", value: "csr"},
    { display: "Sales", value: "sales"},
]